/**
 * Input Schema of MotoristaResponsavel
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {MotoristaResponsavel} from '@/model/resource/MotoristaResponsavel'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputMotoristaResponsavelSchema extends Schema {
  collectionMotorista = new MotoristaCollection().noPagination()
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputMotoristaResponsavel'

  readonly fieldSet: FieldSet<MotoristaResponsavel> = {
    motorista: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionMotorista.all(),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    apelido: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
